import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "./careGiver.css";
import cover from "../../Assets/cover.png";
import heartfelt from "../../Assets/heartfelt.png";
import quote from "../../Assets/icon.png";
import superheroes from "../../Assets/superheroes.png"
import ServicesGrid from "../ServiceGrid";
import ServiceShowcase from "../ServiceShowCase.jsx";
import '../serviceGrid.css'
import "./caregiverdata.js"
import {
    careOptions, personalCareOptions, medicalCareOptions, bedCareOptions,
    postOperativeCare, countOn, testimonialData, truncateLetters, settings,
    settings2, caregiverexpert_p, exploreourh2, exploreourh4, h2div, personalcareh2,
    medicalcareh2, bedsideh2, postoperativeh2, countonh2, serviceShowcaseData
} from "./caregiverdata.js";
import CardsContainer from "../CardsContainer.jsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import CardSlider from "../CardSlider.jsx";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal.js";
import { useNavigate } from "react-router-dom";

function CareGiver() {
   const navigate = useNavigate();
    return (
        <>
            <Header />
            <div className="caregiver-cover-hero">
                <img className="caregiver-cover" src={cover} alt="cover" />
                <h1 className="caregiver-cover-title">Care Giver</h1>
            </div>

            <div className="servicesShowCase">
                {serviceShowcaseData.map((service, index) => (
                    <ServiceShowcase
                        key={index}
                        className="care-giver-servicewrapper"
                        data={service}
                        onServiceClick={() => navigate('/')}

                    />
                ))}
            </div>
            
            <h2 className="caregiver-expert-care-h2">
                Compassion Never Goes Out Of Fashion
            </h2>
            <p className="caregiver-expert-care-p">
                {caregiverexpert_p}
            </p>

            <CardSlider
                className="explore-our-slider"
                heading={careOptions.heading}
                heading2={careOptions.subheading}
                data={careOptions.services} />

            <CardSlider className="personal-care-slider" heading={personalCareOptions.heading} data={personalCareOptions.services} />

            <div className="medical-care">
                <h2>{medicalcareh2}</h2>
                <div className="medicalcare-cards">
                    {Object.entries(medicalCareOptions).map(([key, item]) => (
                        <div key={key} className="medicalcare-card">
                            <img src={item.img} alt={item.title} />
                            <div className="medicalcare-card-info">
                                <h3>{item.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <CardSlider className="bed-side-slider" heading={bedCareOptions.heading} data={bedCareOptions.services} />

            <CardSlider heading={postOperativeCare.heading} data={postOperativeCare.services} />

            <div className="superheroes">
                <div className="superheroes-left">
                    <div className="care-texts">
                        <div className="h2div">
                            <h2>{h2div.heading2}</h2>
                        </div>
                        <p>
                            {h2div.p}
                        </p>
                    </div>
                </div>
                <div className="superheroes-right">
                    <img src={superheroes} alt="superhero caregivers" />
                </div>
            </div>

            <CardsContainer
                heading={countonh2}
                services={Object.values(countOn)}
            />
            <Testimonials
                data={testimonialData}
                textKey="desc"
                imgKey="userimg"
                nameKey="username"
                // settings={settings}
                className="care-giver-testimonials"
            />

            <ServicesGrid title="Check Our Other Services" exclude="Care Giver" />


            <Footer />
        </>
    );
}

export default CareGiver;
